import React, { useEffect } from 'react';
import styles from './index.module.scss';

const DEFAULT_ASSISTANT_SCRIPT_ID = 'default-assistant-script';
const ASSISTANT_SCRIPT_IDS = [DEFAULT_ASSISTANT_SCRIPT_ID, 'test', 'assistant-embed-script'];

const Home2: React.FC = () => {
  useEffect(() => {
    const origin = window.location.origin;
    window.assistantConfig = {
      staffId: 3961,
      tenantMcid: '97cfc70b-e6f0-44c0-8ba3-804dc61e447a',
      showChat: true,
      GT: 'GT-a8FKHf5GpW1xZYiw7fn2LEdnkCSQ2rCJJX3GJjmO',
      baseUrl: window.location.origin,
      // theme: 'dark',
    };

    if (window.assistantEmbed || ASSISTANT_SCRIPT_IDS.some(id => document.getElementById(id))) return;

    const script = document.createElement('script');
    script.src = `${origin}/embed.js`;
    script.id = DEFAULT_ASSISTANT_SCRIPT_ID;
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>默认智能体调试页</h1>
      <p className={styles.description}>该页面只加载默认智能体，用于和导航智能体隔离排查。</p>
    </div>
  );
};

export default Home2;
